export const updateFavourites = (items, itemId, favourite) => (!favourite
  ? [...items, itemId]
  : items.filter((item) => item !== itemId));

export default { updateFavourites };
